var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirstPhoto(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 240,
    viewBox: "0 0 341 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5185 250.557C-4.42547 195.326 -11.9455 128.889 16.2415 64.5824C44.4286 0.275414 122.483 -7.22958 199.491 4.74642C276.499 16.7224 308.701 -17.8536 332.827 85.5604C356.953 188.974 313.889 250.879 313.889 250.879C313.889 250.879 286.858 285.588 220.016 285.507C205.788 285.49 192.064 286.399 178.783 287.307C165.627 288.207 152.9 289.107 140.554 289.107C106.808 289.109 75.8755 282.385 46.5185 250.557Z",
    fill: "#EDA751"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPhoto);
export default __webpack_public_path__ + "static/media/FirstPhoto.f0917b539eec92ae6384255b951bf865.svg";
export { ForwardRef as ReactComponent };